import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: null,
  name: '',
  isLogoUrlUpdated: false,
  logoUpdatedAt: null,
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    notifyLogoUpdated(state) {
      state.isLogoUrlUpdated = !state.isLogoUrlUpdated; // 토글
      state.logoUpdatedAt = Date.now();
    }
  },
});

export const { notifyLogoUpdated } = companySlice.actions;
export default companySlice.reducer;
